<button
  [disabled]="disabledCancelButton"
  mat-raised-button
  matTooltip="Cancel"
  (click)="handleCancel()"
  >
  Cancel
</button>
<button
  [disabled]="disabledSaveButton"
  mat-raised-button
  matTooltip="Update Attribute"
  (click)="handleSubmit()"
  >
  Update
</button>
@if (showPublish) {
  <button
    mat-raised-button
    matTooltip="Publish Nutrition Menu"
    (click)="handlePublish()"
    >
    Publish Nutrition Menu
  </button>
}
